import { Route } from '@/features/InvoiceReport/Edit/type';
import { ApReportStatus } from 'ap-openapi';

export const isInvoiceKindDetectionTarget = (
  route: Route,
  status: string | undefined
) =>
  route === 'normal' &&
  (status === ApReportStatus.unsubmitted ||
    status === ApReportStatus.rejected ||
    status === ApReportStatus.canceled);
